import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    {
      staticClass:
        "legal-case-banner border-radius-sm position-relative overflow-hidden pa-6 mb-4",
      class: _vm.isMobile
        ? "legal-case-banner__mobile"
        : "legal-case-banner__desktop",
      attrs: { "data-qa": "legal_case_banner" },
    },
    [
      _c("span", {
        staticClass: "legal-case-banner__overlay_darken position-absolute",
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex justify-space-between flex-wrap gr-4" },
        _vm._l(_setup.bannerInfo, function (info, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass:
                "d-flex align-center position-relative text-body-1 bg-gray-0--text mr-2",
            },
            [
              _c(
                VIcon,
                {
                  staticClass: "bg-gray-0--text",
                  attrs: { width: "22px", height: "22px" },
                },
                [_vm._v("\n        " + _vm._s(info.icon) + "\n      ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "pl-4",
                  attrs: { "data-qa": "legal_case_banner_text" },
                },
                [_vm._v("\n        " + _vm._s(info.text) + "\n      ")]
              ),
            ],
            1
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }